import React, { Fragment, useEffect, useState } from "react";
import { _O } from "../modules/utils";

export const Footer = (props) => {
  const [dynamicFontSize, setDynamicFontSize] = useState("11px");
  const [viewMode, setViewMode] = useState(window.innerWidth < 360 ? "SMALL" : "NORM");

  const handleResize = () => {
    if (window.innerWidth < 360) {
      setDynamicFontSize("11px");
      setViewMode("SMALL");
    } else if (window.innerWidth > 360) {
      setDynamicFontSize("12px");
      setViewMode("NORM");
    } else {
      setViewMode("NORM");
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div style={{ padding: "0px 20px 11px", fontSize: dynamicFontSize }}>
      {viewMode === "NORM" ? (
        <Fragment>
          <BottomMenu />
          <ComponyInfo />
        </Fragment>
      ) : (
        <Fragment>
          <SmallBottomMenu />
          <SmallComponyInfo />
        </Fragment>
      )}
    </div>
  );
};

export const BottomMenu = (props) => {
  return (
    <Fragment>
      <div style={{ display: "flex", marginBottom: "20px" }}>
        <div onClick={() => _O.Open("/mp/termsView/service")}>이용약관</div>
        <DivSeparate />
        <div onClick={() => _O.Open("/mp/termsView/priv")}>개인정보처리방침</div>
        <DivSeparate />
        <div>고객센터</div>
        <div>1877-4872</div>
        <div>(09:00~18:00)</div>
      </div>
    </Fragment>
  );
};

export const SmallBottomMenu = () => {
  return (
    <Fragment>
      <div style={{ marginBottom: "20px" }}>
        <div style={{ display: "flex" }}>
          <div>이용약관</div>
          <DivSeparate />
          <div>개인정보처리방침</div>
        </div>

        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "2px" }}>고객센터</div>
          <div style={{ marginRight: "2px" }}>1877-4872</div>
          <div>(09:00~18:00)</div>
        </div>
      </div>
    </Fragment>
  );
};

export const ComponyInfo = () => {
  return (
    <div>
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
          <div style={{ fontWeight: "700", marginRight: "2px" }}>
            (주)미라벨소프트
          </div>
          <div>[대표:박기호]</div>
        </div>

        <DivSeparate />

        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "2px" }}>사업자등록번호</div>
          <div style={{ fontWeight: "700" }}>535-88-01537</div>
        </div>
      </div>

      <div>서울특별시 서초구 효령로 304 국제전자센터 11층 11054호</div>

      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "4px" }}>대표전화</div>

        <div style={{ fontWeight: "700" }}>1877-4872</div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "4px" }}>대표이메일</div>
        <div style={{ fontWeight: "700", textDecoration: "underline" }}>
          mirabellsoft@mirabellsoft.com
        </div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "4px" }}>통신판매신고번호</div>
        <div style={{ fontWeight: "700" }}>제2022-서울서초-0002호</div>
      </div>
    </div>
  );
};

export const SmallComponyInfo = () => {
  return (
    <div>
      <div style={{ display: "flex" }}>
        <div style={{ display: "flex" }}>
          <div style={{ fontWeight: "700", marginRight: "2px" }}>
            (주)미라벨소프트
          </div>
          <div>[대표:박기호]</div>
        </div>
      </div>

      <div>
        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "2px" }}>사업자등록번호</div>
          <div style={{ fontWeight: "700" }}>535-88-01537</div>
        </div>
      </div>

      <div>서울특별시 서초구 효령로 304 국제전자센터 11층 11054호</div>

      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "4px" }}>대표전화</div>

        <div style={{ fontWeight: "700" }}>1877-4872</div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "4px" }}>대표이메일</div>
        <div style={{ fontWeight: "700", textDecoration: "underline" }}>
          mirabellsoft@mirabellsoft.com
        </div>
      </div>

      <div style={{ display: "flex" }}>
        <div style={{ marginRight: "4px" }}>통신판매신고번호</div>
        <div style={{ fontWeight: "700" }}>제2022-서울서초-0002호</div>
      </div>
    </div>
  );
};

const DivSeparate = () => {
  return <div style={{ margin: "0px 2px" }}>|</div>;
};
